// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bdaf4c69","455":"39487a9a","977":"5fed09bb"}[chunkId] + ".chunk.js";
};